// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-coach-empty {
  text-align: center;
  padding: 28px 16px 20px;
  position: relative;
  max-width: 420px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.lt-coach-empty__pulse {
  position: absolute;
  inset: 18% 12%;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22),
    transparent 70%
  );
  animation: lt-pulse 2.5s ease-in-out infinite;
  pointer-events: none;
}

.lt-coach-empty__club-logo {
  margin-bottom: 14px;
  position: relative;
}

.lt-coach-empty__club-logo .lt-club-logo-wrap__name {
  display: block;
  text-align: center;
  max-width: 200px;
  margin-top: 6px;
  font-size: 0.85rem;
}

.lt-coach-empty__title {
  position: relative;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 8px;
  letter-spacing: -0.02em;
}

.lt-coach-empty__hint {
  position: relative;
  color: rgba(248, 250, 252, 0.72);
  font-size: 0.9rem;
  line-height: 1.45;
  margin: 0 0 18px;
}

.lt-coach-empty__countdown {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 20px;
  margin-bottom: 18px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.lt-coach-empty__countdown-label {
  font-size: 0.72rem;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.55);
}

.lt-coach-empty__countdown-value {
  font-size: 1.5rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #fbbf24;
}

.lt-coach-empty__actions {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.lt-coach-empty__btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 13px 16px;
  border-radius: 14px;
  font: inherit;
  font-size: 0.95rem;
  font-weight: 650;
  cursor: pointer;
  border: 1px solid transparent;
  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), filter 0.2s ease,
    background 0.2s ease, border-color 0.2s ease;
}

.lt-coach-empty__btn:hover {
  transform: translateY(-1px);
}

.lt-coach-empty__btn:active {
  transform: scale(0.98);
}

.lt-coach-empty__btn--primary {
  background: var(--lt-brand, var(--brand-primary, #0877bc));
  color: #fff;
  box-shadow: 0 10px 24px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);
}

.lt-coach-empty__btn--primary:hover {
  filter: brightness(1.06);
}

.lt-coach-empty__btn--secondary {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 16%, transparent);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);
  color: #f8fafc;
}

.lt-coach-empty__btn--ghost {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.18);
  color: rgba(248, 250, 252, 0.85);
}

.lt-coach-empty__btn--ghost:hover {
  background: rgba(255, 255, 255, 0.06);
}

@media (prefers-reduced-motion: reduce) {
  .lt-coach-empty__pulse {
    animation: none;
  }

  .lt-coach-empty__btn,
  .lt-coach-empty__btn:hover,
  .lt-coach-empty__btn:active {
    transition: none;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingCoachEmptySetup.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB;;;;GAIC;EACD,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B;gDAC8C;AAChD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0DAA0D;EAC1D,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yEAAyE;EACzE,2EAA2E;EAC3E,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".lt-coach-empty {\n  text-align: center;\n  padding: 28px 16px 20px;\n  position: relative;\n  max-width: 420px;\n  margin: 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.lt-coach-empty__pulse {\n  position: absolute;\n  inset: 18% 12%;\n  border-radius: 50%;\n  background: radial-gradient(\n    circle,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22),\n    transparent 70%\n  );\n  animation: lt-pulse 2.5s ease-in-out infinite;\n  pointer-events: none;\n}\n\n.lt-coach-empty__club-logo {\n  margin-bottom: 14px;\n  position: relative;\n}\n\n.lt-coach-empty__club-logo .lt-club-logo-wrap__name {\n  display: block;\n  text-align: center;\n  max-width: 200px;\n  margin-top: 6px;\n  font-size: 0.85rem;\n}\n\n.lt-coach-empty__title {\n  position: relative;\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0 0 8px;\n  letter-spacing: -0.02em;\n}\n\n.lt-coach-empty__hint {\n  position: relative;\n  color: rgba(248, 250, 252, 0.72);\n  font-size: 0.9rem;\n  line-height: 1.45;\n  margin: 0 0 18px;\n}\n\n.lt-coach-empty__countdown {\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 10px 20px;\n  margin-bottom: 18px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.lt-coach-empty__countdown-label {\n  font-size: 0.72rem;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.55);\n}\n\n.lt-coach-empty__countdown-value {\n  font-size: 1.5rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: #fbbf24;\n}\n\n.lt-coach-empty__actions {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.lt-coach-empty__btn {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 13px 16px;\n  border-radius: 14px;\n  font: inherit;\n  font-size: 0.95rem;\n  font-weight: 650;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), filter 0.2s ease,\n    background 0.2s ease, border-color 0.2s ease;\n}\n\n.lt-coach-empty__btn:hover {\n  transform: translateY(-1px);\n}\n\n.lt-coach-empty__btn:active {\n  transform: scale(0.98);\n}\n\n.lt-coach-empty__btn--primary {\n  background: var(--lt-brand, var(--brand-primary, #0877bc));\n  color: #fff;\n  box-shadow: 0 10px 24px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);\n}\n\n.lt-coach-empty__btn--primary:hover {\n  filter: brightness(1.06);\n}\n\n.lt-coach-empty__btn--secondary {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 16%, transparent);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);\n  color: #f8fafc;\n}\n\n.lt-coach-empty__btn--ghost {\n  background: transparent;\n  border-color: rgba(255, 255, 255, 0.18);\n  color: rgba(248, 250, 252, 0.85);\n}\n\n.lt-coach-empty__btn--ghost:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lt-coach-empty__pulse {\n    animation: none;\n  }\n\n  .lt-coach-empty__btn,\n  .lt-coach-empty__btn:hover,\n  .lt-coach-empty__btn:active {\n    transition: none;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
